import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

const ConfigService = {
  ...CrudService(API_RESOURCE.CONFIG),
  fetchConfigByType: async (type) => {
    const response = await axios.get(`${API_RESOURCE.CONFIG}/type/${type}`)
    return response.data
  },
}

export default ConfigService
